"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPlaybookAsync = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
exports.fetchPlaybookAsync = (0, typesafe_actions_1.createAsyncAction)(constants_1.FETCH_PLAYBOOK_REQUEST, constants_1.FETCH_PLAYBOOK_SUCCESS, constants_1.FETCH_PLAYBOOK_FAILED, constants_1.FETCH_PLAYBOOK_CANCEL)();